module.exports = __webpack_public_path__ + "img/logo_kr.d8622c15.svg";